import { render, staticRenderFns } from "./ProductAssets.vue?vue&type=template&id=1d4fdd98&"
import script from "./ProductAssets.vue?vue&type=script&lang=js&"
export * from "./ProductAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports